
const Vr2 = () => {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-2/PNG%20n.4/3d%202-4/publish%202-4/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 2 Tour"
        ></iframe>
      </div>
    );
};

export default Vr2;
